import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, map, startWith, tap } from 'rxjs/operators';
import { FormValueService } from 'src/app/shared/service/form/form-value.service';

@Component({
  selector: 'app-dynamic-input',
  templateUrl: './dynamic-input.component.html',
  styleUrls: ['./dynamic-input.component.scss']
})
export class DynamicInputComponent implements OnInit {
  @Input() field: any;
  formName: FormGroup;
  filteredOptions!: Observable<any>;

  constructor(
    private formgroupDirective: FormGroupDirective,
    private formValueService : FormValueService,
    ) {
    this.formName = formgroupDirective.control;
  }

  ngOnInit(): void {
    // Esta a la escuccha de cualquier cambio que se haga en el formulario
    this.formValueService.setForm(this.formName);
    this.getPostalCode();
  }

  get getFieldName (){
    return this.formName.controls[this.field.fieldName];
  }

  private getPostalCode():void{
    if (this.field.fieldName === 'CodigoPostal') {
      this.formName.get(this.field.fieldName)!.valueChanges
      .pipe(
        debounceTime(3000),
      )
      .subscribe(
        value => {
          if (value.length >4) {
            this.formValueService.emitPostalCode(value);
          }
        }
      )
    }
  }


}
